import React from "react";

import {
  SECTION_TITLE_COLOR_CLASSES,
  SECTION_TITLE_SIZE_CLASSES,
} from "./SectionTitle.constants";
import { SectionTitleProps } from "./SectionTitle.types";

export const SectionTitle: React.FC<SectionTitleProps> = ({
  children,
  size = "md",
  color = "primary",
  className,
}) => (
  <div
    className={[
      "mb-3 font-Manrope font-bold uppercase tracking-[0.8px]",
      SECTION_TITLE_SIZE_CLASSES[size],
      SECTION_TITLE_COLOR_CLASSES[color],
      className,
    ]
      .filter(Boolean)
      .join(" ")}>
    {children}
  </div>
);
